import { LayoutMode } from "views/Account/ConfigManagement/types";
import { AnsibleGroupBy } from "views/Account/ConfigManagement/types";

export const LAYOUT_MODE_LOCAL_STORAGE_KEY = "stack-config-management-layout-mode";
export const DEFAULT_LAYOUT_MODE = LayoutMode.Diagram;
export const FILTERS_ORDER_SETTINGS_KEY = "searchStackHosts";
export const GROUP_BY_MODE_LOCAL_STORAGE_KEY = "stack-config-management-group-by-mode";
export const DEFAULT_GROUP_BY_MODE = AnsibleGroupBy.Hosts;
export const HIDDEN_FILTERS = ["stack"];
